import { defineMessages } from "react-intl";
const messages = defineMessages({
    minLabel: { id: "app.aiDiscoverability.rankingWidget.minLabel", defaultMessage: "(min)" },
    maxLabel: { id: "app.aiDiscoverability.rankingWidget.maxLabel", defaultMessage: "(max)" },
    // Shared by every ranking chart's "You" marker. Keeps its pre-existing id so the
    // en.json entry extracted under top-ranking still applies.
    tooltipYou: {
        id: "app.aiDiscoverability.topRanking.tooltipYou",
        defaultMessage: "You're ranked #{rank} of {total} communities",
    },
});
export default messages;
